import React, { useEffect, useState } from "react";
import { authApi } from "../modules/services/authService";

const AuthVerify = (props: any) => {
  const [time, setTime] = useState(0);
  const [checkAuth] = authApi.useCheckTokenMutation();

  useEffect(() => {
    const user = localStorage.getItem("token");
    if (user) {
      checkAuth({})
        .then((res: any) => {
          if (res?.error?.data?.statusCode === 401) {
            props.logOut();
          }
        });
    }
    setTimeout(() => {
      setTime(time + 1);
    }, 600000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);

  return <></>;
};

export default AuthVerify;
